var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5,24H16c-1.1,0-2-0.9-2-2v-5.5h-4V22c0,1.1-0.9,2-2,2H4.5C2.6,24,1,22.4,1,20.5V9.9c0-1.3,0.6-2.5,1.6-3.2 l8.8-6.5c0.4-0.3,0.8-0.3,1.2,0l8.8,6.5c1,0.8,1.6,2,1.6,3.2v10.6C23,22.4,21.4,24,19.5,24z M9.5,14.5h5c0.8,0,1.5,0.7,1.5,1.5v6 h3.5c0.8,0,1.5-0.7,1.5-1.5V9.9c0-0.6-0.3-1.2-0.8-1.6l-8.2-6l-8.2,6C3.3,8.6,3,9.2,3,9.9v10.6C3,21.3,3.7,22,4.5,22H8v-6 C8,15.2,8.7,14.5,9.5,14.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.a7b4842a639d7e55d9ba60d0c5e4cb5f.svg";
export { ForwardRef as ReactComponent };